import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "md:flex-no-shrink md:w-2/3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "my-10"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = {
  key: 0,
  src: "https://bolia-com-d365-qa.azurewebsites.net/globalassets/media/some/instagram.svg",
  alt: "",
  class: "w-20 h-20 mr-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _component_LazyInit = _resolveComponent("LazyInit")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["px-20 md:flex md:items-center md:p-0 lg:relative", _ctx.flexOrderClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MediaHandler, {
        "video-disable-on-mobile": _ctx.content.disableVideoOnMobile,
        "media-aspect-ratio": _ctx.aspectRatio,
        "media-block": _ctx.mediaTileContentBlock.media
      }, null, 8, ["video-disable-on-mobile", "media-aspect-ratio", "media-block"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["px-10 pt-10 w-full sm:w-1/2 md:w-1/3 md:pt-0 md:px-25 lg:p-0 lg:absolute lg:w-2/5", _ctx.absolutePositionClasses])
    }, [
      (_ctx.textTileContentBlock.subheading)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "o-text-caption uppercase m-0",
            innerHTML: _ctx.textTileContentBlock.subheading
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.textTileContentBlock.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 1,
            innerHTML: _ctx.textTileContentBlock.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.textTileContentBlock.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.textTileContentBlock.text), 1))
        : _createCommentVNode("", true),
      (_ctx.textTileContentBlock.soMeLinks && _ctx.textTileContentBlock.soMeLinks[0])
        ? (_openBlock(), _createBlock(_component_LazyInit, { key: 3 }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textTileContentBlock.soMeLinks, (soMeLink) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: soMeLink.url,
                    class: "flex items-center mb-10"
                  }, [
                    true
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : _createCommentVNode("", true),
                    _createVNode(_component_CMSLinkHandler, {
                      "link-block": soMeLink,
                      "style-as-button": false
                    }, null, 8, ["link-block"])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}